import React, { useState, useEffect } from 'react';
import StarRatings from 'react-star-ratings';

const WineCard = ({ wine, idx, onAddToCart, outOfStock }) => {
  // Hook to detect mobile screen size
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Check on mount
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup event listener on unmount
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Utilidad para mostrar el precio
  const getPrice = (value) => {
    if (!value) return '-';
    let val = String(value).replace(/\s/g, '');
    if (val.includes(',')) val = val.split(',')[0];
    val = val.replace(/\D/g, '');
    const num = Number(val);
    return !isNaN(num) && num > 0
      ? num.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      : '-';
  };

  if (isMobile) {
    // Mobile horizontal layout
    return (
      <div
        className="w-100"
        style={{
                  background: outOfStock ? '#f5f5f5' : 'white',
        borderRadius: '16px',
        boxShadow: outOfStock
          ? '0 0 0 2px #e57373'
          : '0 2px 12px rgba(113,131,142,0.15)',
        padding: '0',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '280px',
          width: '100%',
          opacity: outOfStock ? 0.7 : 1,
          position: 'relative',
          filter: outOfStock ? 'grayscale(0.5)' : 'none',
          overflow: 'hidden',
          transition: 'box-shadow 0.2s, transform 0.2s',
          marginBottom: '1rem'
        }}
      >
        {/* Top section: Image and Rating/Price */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '1.2rem',
          marginBottom: '1rem',
          padding: '1rem 1rem 0 1rem'
        }}>
          {/* Wine Image */}
          <div style={{
            width: '130px',
            height: '190px',
            background: '#f8f8f8',
            borderRadius: '10px',
            boxShadow: '0 1px 6px rgba(160,58,43,0.07)',
            flexShrink: 0,
            overflow: 'hidden'
          }}>
            <img
              src={wine.imagen ? wine.imagen : "https://pampawineclub.com/img/pw_default.png"}
              alt={wine.descripcion}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                filter: outOfStock ? 'grayscale(0.7)' : 'none',
                transition: 'filter 0.2s'
              }}
            />
          </div>

          {/* Rating and Price Section */}
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}>
            <>
              {wine.vivino && (
                <div style={{ 
                  fontSize: '2.2rem', 
                  fontWeight: 700, 
                  color: '#a03a2b', 
                  lineHeight: 1, 
                  marginBottom: '0.3rem' 
                }}>
                  {parseFloat(String(wine.vivino).replace(',', '.')).toFixed(1)}
                </div>
              )}
              <StarRatings
                rating={wine.vivino ? parseFloat(String(wine.vivino).replace(',', '.')) : 0}
                starRatedColor="#a03a2b"
                numberOfStars={5}
                starDimension="18px"
                starSpacing="2px"
                starEmptyColor="#ddd"
                name={`vivino-rating-${idx}`}
              />
              {wine.vivino ? (
                wine.puntaje_pwc && (
                  <div style={{ 
                    fontSize: '0.85rem', 
                    color: '#b89d2a', 
                    marginTop: '0.2rem', 
                    fontWeight: 600 
                  }}>
                    {wine.puntaje_pwc} valoraciones
                  </div>
                )
              ) : (
                <div style={{
                  fontSize: '0.85rem',
                  color: '#b89d2a',
                  marginTop: '0.2rem',
                  fontWeight: 600,
                  textAlign: 'center'
                }}>
                  Aún no calificado
                </div>
              )}
            </>
            
            <div style={{ 
              fontSize: '1.4rem', 
              fontWeight: 700, 
              color: '#a03a2b', 
              marginTop: '0.8rem',
              lineHeight: 1
            }}>
              ARS {getPrice(wine.cons_final)}
            </div>
            <div style={{ 
              fontSize: '0.8rem', 
              color: '#888',
              marginTop: '0.1rem'
            }}>
              Precio final
            </div>
          </div>
        </div>

        {/* Wine Details Section */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.3rem',
          marginBottom: '1rem',
          padding: '0 1rem'
        }}>
          <div style={{
            fontSize: '1.1rem',
            fontWeight: 700,
            color: '#2d2b27',
            lineHeight: 1.2
          }}>
            {wine.descripcion}
          </div>
          <div style={{
            fontSize: '0.95rem',
            color: '#a03a2b',
            fontWeight: 600
          }}>
            {wine.bodega}
          </div>
          <div style={{
            fontSize: '0.9rem',
            color: '#555',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <span>🇦🇷</span>
            <span>{wine.provincia || ''}{wine.provincia && wine.cepa ? ' · ' : ''}{wine.cepa || ''}</span>
          </div>
        </div>

        {/* Button Section */}
        <div style={{
          marginTop: 'auto',
          padding: '0 1rem 1rem 1rem'
        }}>
          {outOfStock ? (
            <div style={{
              background: '#e57373',
              color: 'white',
              borderRadius: '8px',
              padding: '0.8rem 1rem',
              fontWeight: 700,
              fontSize: '0.95rem',
              textAlign: 'center',
              letterSpacing: '0.01em',
              boxShadow: '0 1px 6px rgba(229,115,115,0.13)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '44px',
              lineHeight: '1.4'
            }}>
              SIN STOCK
            </div>
          ) : (
            <button
              className="btn"
              style={{
                background: '#a03a2b',
                color: 'white',
                borderRadius: '8px',
                padding: '0.8rem 1rem',
                fontWeight: 700,
                fontSize: '0.95rem',
                border: 'none',
                letterSpacing: '0.01em',
                boxShadow: '0 1px 6px rgba(160,58,43,0.13)',
                transition: 'background 0.2s, transform 0.2s',
                lineHeight: '1.4',
                width: '100%',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '44px'
              }}
              onClick={() => onAddToCart(wine)}
            >
              Agregar al carrito
            </button>
          )}
        </div>
      </div>
    );
  }

  // Desktop horizontal layout (image on left)
  return (
    <div
      className="w-100"
      style={{
        background: outOfStock ? '#f5f5f5' : 'white',
        borderRadius: '18px',
        boxShadow: outOfStock
          ? '0 0 0 2px #e57373'
          : '0 4px 18px rgba(113,131,142,0.13)',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '380px',
        width: '100%',
        opacity: outOfStock ? 0.7 : 1,
        position: 'relative',
        filter: outOfStock ? 'grayscale(0.5)' : 'none',
        overflow: 'hidden',
        transition: 'box-shadow 0.2s, transform 0.2s',
      }}
    >
      {/* Top section: Image and Content */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'stretch', 
        gap: '2rem',
        marginBottom: '1.2rem',
        flex: 1,
        padding: '1.5rem 1.5rem 0 1.5rem'
      }}>
        {/* Wine Image */}
                <div style={{
          width: '170px',
          minHeight: '220px',
          background: '#f8f8f8',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(160,58,43,0.08)',
          flexShrink: 0,
          overflow: 'hidden'
        }}>
          <img
            src={wine.imagen ? wine.imagen : "https://pampawineclub.com/img/pw_default.png"}
            alt={wine.descripcion}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              filter: outOfStock ? 'grayscale(0.7)' : 'none',
              transition: 'filter 0.2s'
            }}
          />
        </div>

        {/* Content Section */}
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
          {/* Wine Details */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            marginBottom: '1rem'
          }}>
            <div style={{
              fontSize: '1.3rem',
              fontWeight: 700,
              color: '#2d2b27',
              lineHeight: 1.3,
              marginBottom: '0.3rem'
            }}>
              {wine.descripcion}
            </div>
            <div style={{
              fontSize: '1.1rem',
              color: '#a03a2b',
              fontWeight: 600,
              marginBottom: '0.2rem'
            }}>
              {wine.bodega}
            </div>
            <div style={{
              fontSize: '1rem',
              color: '#555',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '0.5rem'
            }}>
              <span>🇦🇷</span>
              <span>{wine.provincia || ''}{wine.provincia && wine.cepa ? ' · ' : ''}{wine.cepa || ''}</span>
            </div>
          </div>

          {/* Rating and Price Section */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#faf7f0',
            borderRadius: '12px',
            padding: '1rem',
            boxShadow: '0 2px 8px rgba(184,157,42,0.08)'
          }}>
            {/* Rating */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <>
                {wine.vivino && (
                  <div style={{ 
                    fontSize: '2rem', 
                    fontWeight: 700, 
                    color: '#a03a2b', 
                    lineHeight: 1, 
                    marginBottom: '0.3rem' 
                  }}>
                    {parseFloat(String(wine.vivino).replace(',', '.')).toFixed(1)}
                  </div>
                )}
                <StarRatings
                  rating={wine.vivino ? parseFloat(String(wine.vivino).replace(',', '.')) : 0}
                  starRatedColor="#a03a2b"
                  numberOfStars={5}
                  starDimension="20px"
                  starSpacing="2px"
                  starEmptyColor="#ddd"
                  name={`vivino-rating-${idx}`}
                />
                {wine.vivino ? (
                  wine.puntaje_pwc && (
                    <div style={{ 
                      fontSize: '0.85rem', 
                      color: '#b89d2a', 
                      marginTop: '0.2rem', 
                      fontWeight: 600,
                      textAlign: 'center'
                    }}>
                      {wine.puntaje_pwc} valoraciones
                    </div>
                  )
                ) : (
                  <div style={{
                    fontSize: '0.85rem',
                    color: '#b89d2a',
                    marginTop: '0.2rem',
                    fontWeight: 600,
                    textAlign: 'center'
                  }}>
                    Aún no calificado
                  </div>
                )}
              </>
            </div>

            {/* Price */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }}>
              <div style={{ 
                fontSize: '1.6rem', 
                fontWeight: 700, 
                color: '#a03a2b', 
                lineHeight: 1,
                marginBottom: '0.2rem'
              }}>
                ARS {getPrice(wine.cons_final)}
              </div>
              <div style={{ 
                fontSize: '0.9rem', 
                color: '#888'
              }}>
                Precio final
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Button Section */}
      <div style={{
        marginTop: 'auto',
        padding: '0 1.5rem 1.5rem 1.5rem'
      }}>
        {outOfStock ? (
          <div style={{
            background: '#e57373',
            color: 'white',
            borderRadius: '10px',
            padding: '1rem 1.5rem',
            fontWeight: 700,
            fontSize: '1.1rem',
            textAlign: 'center',
            letterSpacing: '0.01em',
            boxShadow: '0 2px 8px rgba(229,115,115,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50px',
            lineHeight: '1.4'
          }}>
            SIN STOCK
          </div>
        ) : (
          <button
            className="btn"
            style={{
              background: '#a03a2b',
              color: 'white',
              borderRadius: '10px',
              padding: '1rem 1.5rem',
              fontWeight: 700,
              fontSize: '1.1rem',
              border: 'none',
              letterSpacing: '0.01em',
              boxShadow: '0 2px 8px rgba(160,58,43,0.15)',
              transition: 'background 0.2s, transform 0.2s',
              lineHeight: '1.4',
              width: '100%',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '50px'
            }}
            onClick={() => onAddToCart(wine)}
          >
            Agregar al carrito
          </button>
        )}
      </div>
    </div>
  );
};

export default WineCard; 